class PredictiveSearch {
    constructor() {
        this.overlay = document.getElementById('search-overlay');
        this.input = document.getElementById('search-input');
        this.resultsContainer = document.getElementById('search-results');
        this.loadingIndicator = document.getElementById('search-loading');
        this.closeBtn = document.getElementById('close-search');
        this.searchBtns = document.querySelectorAll('.search-btn');

        if (this.overlay && this.input && this.resultsContainer && this.loadingIndicator) {
            this.setupEventListeners();
        }
    }

    setupEventListeners() {
        // Open search
        this.searchBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.open();
            });
        });

        // Close search
        this.closeBtn?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', (e) => {
            if (e.target === this.overlay) this.close();
        });

        // Close on ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });

        // Search input
        let timeout;
        this.input?.addEventListener('input', () => {
            window.clearTimeout(timeout);
            
            const inputElement = this.input;
            if (!inputElement || !(inputElement instanceof HTMLInputElement)) return;

            const query = inputElement.value.trim();
            
            if (query.length < 2) {
                if (this.resultsContainer) this.resultsContainer.innerHTML = '';
                return;
            }

            timeout = window.setTimeout(() => this.fetchResults(query), 300);
        });
    }

    async fetchResults(query) {
        if (!this.loadingIndicator) return;
        this.loadingIndicator.style.display = 'flex';
        
        try {
            const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&section_id=predictive-search`);
            const data = await response.json();
            this.renderResults(data.resources.results.products);
        } catch (error) {
            console.error('Search error:', error);
        } finally {
            if (this.loadingIndicator) this.loadingIndicator.style.display = 'none';
        }
    }

    renderResults(products) {
        if (!this.resultsContainer) return;

        if (!products || products.length === 0) {
            this.resultsContainer.innerHTML = '<div class="no-results">No products found.</div>';
            return;
        }

        const html = products.map(product => `
            <a href="${product.url}" class="search-result-item">
                <img src="${product.image || ''}" alt="${product.title}" class="result-image">
                <div class="result-info">
                    <div class="result-vendor">${product.type || product.vendor}</div>
                    <div class="result-title">${product.title}</div>
                    <div class="result-price">${product.price}</div>
                </div>
            </a>
        `).join('');

        this.resultsContainer.innerHTML = html;
    }

    open() {
        if (!this.overlay || !this.input) return;
        this.overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        setTimeout(() => this.input?.focus(), 100);
    }

    close() {
        if (!this.overlay || !this.input || !this.resultsContainer) return;
        this.overlay.classList.remove('active');
        document.body.style.overflow = '';
        if (this.input instanceof HTMLInputElement) {
            this.input.value = '';
        }
        this.resultsContainer.innerHTML = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new PredictiveSearch();
});
